import { createFileRoute, useParams } from "@tanstack/react-router";
import { EntityTypeFormTab } from "@/features/form-editor/components/entity-type-form-tab";

const ROUTE_ID =
	"/_authenticated/(admin-app)/_admin/admin/configuration/ticketTypes/$ticketTypeId/schema" as const;

export const Route = createFileRoute(ROUTE_ID)({
	component: AdminTicketTypeSchemaTab,
});

function AdminTicketTypeSchemaTab() {
	const { ticketTypeId } = useParams({ from: ROUTE_ID });
	return (
		<EntityTypeFormTab entity="ticket" typeId={ticketTypeId} scope="admin" />
	);
}
